import { LEGAL_SECTIONS, CURRENT_TERMS_VERSION, TERMS_LAST_UPDATED } from '../lib/legalText.js';

// Renders the TrainForge legal text from the shared LEGAL_SECTIONS data. Used
// by the first-login terms gate (RequireTerms) and the Profile Legal card so
// the on-screen text and the snapshot/download all come from one source.
export default function LegalDocument({ version = CURRENT_TERMS_VERSION }) {
  return (
    <>
      {LEGAL_SECTIONS.map((section, i) => (
        <div key={section.heading}>
          <h3 style={{ color: 'var(--text)', marginTop: i === 0 ? 0 : undefined }}>{section.heading}</h3>
          {section.paragraphs.map((p, j) => (
            <p key={j}>
              {p.lead ? <b>{p.lead} </b> : null}
              {p.text}
            </p>
          ))}
        </div>
      ))}
      <p style={{ color: 'var(--text-muted)', marginTop: 24, fontSize: 11 }}>
        Terms version {version} · Last updated {TERMS_LAST_UPDATED}
      </p>
    </>
  );
}
